/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Testimonial_2_QuoteInputs */

const en_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I've worked with coaches across the country. Nobody teaches the swing like Mark.`)
};

const es_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`He trabajado con entrenadores de todo el país. Nadie enseña el swing como Mark.`)
};

const de_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe mit Trainern im ganzen Land gearbeitet. Niemand unterrichtet den Schwung wie Mark.`)
};

const zh_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我和全国各地的教练合作过。没有人像 Mark 这样教挥杆。`)
};

const ar_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عملت مع مدرّبين في أنحاء البلاد. لا أحد يعلّم السوينغ مثل Mark.`)
};

const fr_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai travaillé avec des entraîneurs dans tout le pays. Personne n'enseigne le swing comme Mark.`)
};

const vi_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tôi đã làm việc với các huấn luyện viên trên khắp đất nước. Không ai dạy swing như Mark.`)
};

const sw_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimefanya kazi na makocha kote nchini. Hakuna anayefundisha swing kama Mark.`)
};

const th_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผมเคยเรียนกับโค้ชมาทั่วประเทศ ไม่มีใครสอนวงสวิงได้เหมือน Mark`)
};

const bs_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radio sam s trenerima širom zemlje. Niko ne podučava swing kao Mark.`)
};

const ja_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全国のコーチに習ってきましたが、Markほどスイングを上手に教えられる人はいません。`)
};

const ko_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전국의 여러 코치에게 배워 봤습니다. 아무도 Mark처럼 스윙을 가르치지 않습니다.`)
};

const pt_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhei com treinadores de todo o país. Ninguém ensina o swing como o Mark.`)
};

const it_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho lavorato con gli allenatori in tutto il paese. Nessuno insegna lo swing come Mark.`)
};

const sv_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag har tränat för tränare över hela landet. Ingen lär ut svingen som Mark.`)
};

const nl_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik heb met coaches door het hele land gewerkt. Niemand leert de swing zoals Mark.`)
};

const da_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg har arbejdet med trænere over hele landet. Ingen underviser i svinget som Mark.`)
};

const nb_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg har jobbet med trenere over hele landet. Ingen lærer bort svingen som Mark.`)
};

const fi_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olen työskennellyt valmentajien kanssa ympäri maata. Kukaan ei opeta swingiä niin kuin Mark.`)
};

const pl_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracowałem z trenerami w całym kraju. Nikt nie uczy swingu jak Mark.`)
};

const ru_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я работал с тренерами по всей стране. Никто не учит свингу, как Mark.`)
};

const tr_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ülkenin dört bir yanındaki antrenörlerle çalıştım. Kimse swingi Mark gibi öğretmiyor.`)
};

const hi_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैंने देश भर के कोचों के साथ काम किया है। कोई भी Mark की तरह स्विंग नहीं सिखाता।`)
};

const id_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya telah bekerja dengan pelatih di seluruh negeri. Tidak ada yang mengajarkan ayunan seperti Mark.`)
};

const ms_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya pernah berlatih dengan jurulatih di seluruh negara. Tiada siapa yang mengajar hayunan seperti Mark.`)
};

const cs_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pracoval jsem s trenéry po celé zemi. Nikdo neučí švih jako Mark.`)
};

const el_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έχω δουλέψει με προπονητές σε όλη τη χώρα. Κανείς δεν διδάσκει το σβινγκ σαν τον Mark.`)
};

const he_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עבדתי עם מאמנים ברחבי הארץ. אף אחד לא מלמד את הסווינג כמו Mark.`)
};

const af_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ek het met afrigters dwarsoor die land gewerk. Niemand leer die swing soos Mark nie.`)
};

const hu_home_testimonial_2_quote = /** @type {(inputs: Home_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dolgoztam edzőkkel szerte az országban. Senki sem tanítja úgy a swinget, mint Mark.`)
};

/**
* | output |
* | --- |
* | "I've worked with coaches across the country. Nobody teaches the swing like Mark." |
*
* @param {Home_Testimonial_2_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_testimonial_2_quote = /** @type {((inputs?: Home_Testimonial_2_QuoteInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Testimonial_2_QuoteInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_testimonial_2_quote(inputs)
	if (locale === "de") return de_home_testimonial_2_quote(inputs)
	if (locale === "zh") return zh_home_testimonial_2_quote(inputs)
	if (locale === "ar") return ar_home_testimonial_2_quote(inputs)
	if (locale === "fr") return fr_home_testimonial_2_quote(inputs)
	if (locale === "vi") return vi_home_testimonial_2_quote(inputs)
	if (locale === "sw") return sw_home_testimonial_2_quote(inputs)
	if (locale === "th") return th_home_testimonial_2_quote(inputs)
	if (locale === "bs") return bs_home_testimonial_2_quote(inputs)
	if (locale === "ja") return ja_home_testimonial_2_quote(inputs)
	if (locale === "ko") return ko_home_testimonial_2_quote(inputs)
	if (locale === "pt") return pt_home_testimonial_2_quote(inputs)
	if (locale === "it") return it_home_testimonial_2_quote(inputs)
	if (locale === "sv") return sv_home_testimonial_2_quote(inputs)
	if (locale === "nl") return nl_home_testimonial_2_quote(inputs)
	if (locale === "da") return da_home_testimonial_2_quote(inputs)
	if (locale === "nb") return nb_home_testimonial_2_quote(inputs)
	if (locale === "fi") return fi_home_testimonial_2_quote(inputs)
	if (locale === "pl") return pl_home_testimonial_2_quote(inputs)
	if (locale === "ru") return ru_home_testimonial_2_quote(inputs)
	if (locale === "tr") return tr_home_testimonial_2_quote(inputs)
	if (locale === "hi") return hi_home_testimonial_2_quote(inputs)
	if (locale === "id") return id_home_testimonial_2_quote(inputs)
	if (locale === "ms") return ms_home_testimonial_2_quote(inputs)
	if (locale === "cs") return cs_home_testimonial_2_quote(inputs)
	if (locale === "el") return el_home_testimonial_2_quote(inputs)
	if (locale === "he") return he_home_testimonial_2_quote(inputs)
	if (locale === "af") return af_home_testimonial_2_quote(inputs)
	if (locale === "hu") return hu_home_testimonial_2_quote(inputs)
	return en_home_testimonial_2_quote(inputs)
});